const SvgIcon = ({ color = '#fff', size = '24' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 25.116 24"
  >
    <path
      fill={color}
      strokeWidth="0.558"
      d="M8.79 3.79a3.8 3.8 0 0 1 1.104-2.68A3.76 3.76 0 0 1 12.558 0c1 0 1.958.4 2.664 1.11a3.801 3.801 0 0 1 0 5.36 3.76 3.76 0 0 1-2.664 1.109c-.999 0-1.957-.4-2.664-1.11a3.8 3.8 0 0 1-1.103-2.68m11.93-2.527a3.13 3.13 0 0 0-2.22.925 3.167 3.167 0 0 0 0 4.466 3.13 3.13 0 0 0 4.44 0 3.167 3.167 0 0 0 0-4.466 3.13 3.13 0 0 0-2.22-.925m-16.325 0a3.13 3.13 0 0 0-2.22.925 3.167 3.167 0 0 0 0 4.466 3.13 3.13 0 0 0 4.44 0 3.167 3.167 0 0 0 0-4.466 3.13 3.13 0 0 0-2.22-.925m5.18 7.58a2.66 2.66 0 0 0-1.886.785 2.7 2.7 0 0 0-.782 1.898v6.79c0 1.507.595 2.953 1.655 4.02A5.64 5.64 0 0 0 12.558 24a5.64 5.64 0 0 0 3.996-1.665 5.7 5.7 0 0 0 1.655-4.02v-6.789c0-.712-.28-1.394-.781-1.898a2.66 2.66 0 0 0-1.887-.786Zm-3.924 2.683c0-1.01.378-1.933 1-2.631a2.7 2.7 0 0 0-.529-.053H2.67a2.66 2.66 0 0 0-1.887.786A2.7 2.7 0 0 0 0 11.526v6.158c0 .764.196 1.514.57 2.179s.912 1.22 1.563 1.613a4.38 4.38 0 0 0 4.33.11 6.95 6.95 0 0 1-.812-3.27Zm13.814 6.79a6.95 6.95 0 0 1-.812 3.27 4.38 4.38 0 0 0 4.33-.11 4.4 4.4 0 0 0 1.563-1.613 4.44 4.44 0 0 0 .57-2.179v-6.158c0-.712-.28-1.394-.781-1.898a2.66 2.66 0 0 0-1.887-.786h-3.454q-.271 0-.529.053c.645.723 1.001 1.66 1 2.631z"
    ></path>
  </svg>
);

export default SvgIcon;
